export const STEP_SIGN_IN = 'STEP_SIGN_IN';
export const STEP_MFA = 'STEP_MFA';